import Axios from "axios";
import jwt from "jsonwebtoken";
import Vue from "vue";
import Vuex from "vuex";

const SECRET = "thisisasupersecretkeytolockmyjsonwebtoken";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbar: {},
    history: [],
    password: "admin",
    beURL: "https://boss-audit-api.bohmtech.com",
    adURL: "https://auth.bohmtech.com/user/search",
    printersURL: "https://api.bohmtech.com/odoo/search/bohmtech.printers/100",
    lightDark: true,
    allPrinters: [],
    printer: "guest",
    users: [],
    overtime: [],
    maxDailySignups: 10,
    maxWeeklySignups: 2,
    blackOutDates: []
  },
  mutations: {
    setSnackbar(state, snackbar) {
      state.snackbar = snackbar;
    },
    setHistory(state, history) {
      state.history = history;
    },
    setLightDark(state, lightDark) {
      state.lightDark = lightDark;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setPrinter(state, printer) {
      state.printer = printer;
    },
    setAllPrinters(state, printers) {
      state.allPrinters = printers;
    },
    setOvertime(state, overtime) {
      state.overtime = overtime;
    },
    setMaxDailySignups(state, max) {
      state.maxDailySignups = max;
    },
    setMaxWeeklySignups(state, max) {
      state.maxWeeklySignups = max;
    },
    setBlackOutDates(state, blackOutDates) {
      state.blackOutDates = blackOutDates;
    }
  },
  getters: {
    getSnackbar(state) {
      return state.snackbar;
    },
    getHistory(state) {
      return state.history;
    },
    getLightDark(state) {
      return state.lightDark;
    },
    getUsers(state) {
      return state.users;
    },
    getPrinter(state) {
      return state.printer;
    },
    getAllPrinters(state) {
      return state.allPrinters;
    },
    getOvertime(state) {
      return state.overtime;
    },
    getMaxDailySignups(state) {
      return state.maxDailySignups;
    },
    getMaxWeeklySignups(state) {
      return state.maxWeeklySignups;
    },
    getBlackOutDates(state) {
      return state.blackOutDates;
    }
  },
  actions: {
    async signIn({ dispatch, state }, data) {
      try {
        await Axios({
          method: "POST",
          url: `${state.beURL}/signin`,
          headers: {
            Authorization: `Bearer ${await dispatch("generateToken")}`
          },
          data
        });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("setSnackbar", {
          text: "Thank you for signing in!",
          color: "accent"
        });
      }
    },

    async updateUser({ dispatch, state }, data) {
      try {
        await Axios({
          method: "PATCH",
          url: `${state.beURL}/signin/${data._id}`,
          headers: {
            Authorization: `Bearer ${await dispatch("generateToken")}`
          },
          data
        });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("setSnackbar", {
          text: "Signed Out!",
          color: "accent"
        });
      }
    },

    async printGuestTag({ dispatch, state }, { name, company }) {
      await Axios({
        method: "POST",
        url: `${state.beURL}/signin/print`,
        headers: {
          Authorization: `Bearer ${await dispatch("generateToken")}`
        },
        data: {
          name,
          company,
          printer: state.printer
        }
      });
    },

    async getUsers({ dispatch, commit, state }, term) {
      term = term.split("(")[0];
      const { data } = await Axios({
        method: "GET",
        url: `${state.adURL}/name/${term}`,
        headers: {
          Authorization: `Bearer ${await dispatch("generateToken")}`
        }
      });

      commit("setUsers", data.user);
    },

    async getHistory(
      { dispatch, commit, state },
      { itemsPerPage, page, sortBy, sortDesc, search, type, signedIn = false }
    ) {
      let url = `${state.beURL}/signin/?limit=${itemsPerPage}`;
      if (page) url += `&page=${page}`;
      if (sortBy) url += `&sort=${sortBy}`;
      if (sortDesc != null) url += `&direction=${sortDesc}`;
      if (search) url += `&search=${search}`;
      if (type) url += `&type=${type}`;
      if (signedIn) url += `&signedIn=${signedIn}`;

      const { data } = await Axios({
        method: "GET",
        url: url,
        headers: {
          Authorization: `Bearer ${await dispatch("generateToken")}`
        }
      });
      data.docs.map(item => {
        item.date = new Date(item.date).toLocaleDateString([], {
          month: "numeric",
          day: "numeric",
          year: "2-digit",
          hour: "2-digit",
          minute: "2-digit"
        });
        item.reason =
          item.reason.charAt(0).toUpperCase() + item.reason.slice(1);
        return item;
      });
      commit("setHistory", data);
    },

    setSnackbar({ commit }, snackbar) {
      commit("setSnackbar", snackbar);
    },

    async getAllPrinters({ dispatch, commit, state }) {
      const printers = await Axios({
        method: "POST",
        url: state.printersURL,
        headers: {
          Authorization: `Bearer ${await dispatch("generateToken")}`
        },
        data: {
          conditions: [
            {
              field: "name",
              operator: "not like",
              value: "zbrp"
            }
          ]
        }
      });
      let printerNames = printers.data.bindle.map(printer => {
        return printer.name;
      });

      commit("setAllPrinters", printerNames.sort());
    },

    async getOvertime(
      { state, dispatch, commit },
      { employeeName, employeeID, weekNumber, signUpDate, setData = true }
    ) {
      let url = `${state.beURL}/overtime/?`;
      if (employeeName) url += `&employeeName=${employeeName}`;
      if (employeeID) url += `&employeeID=${employeeID}`;
      if (weekNumber) url += `&weekNumber=${weekNumber}`;
      if (signUpDate) url += `&signUpDate=${signUpDate}`;

      const { data } = await Axios({
        method: "GET",
        url: url,
        headers: {
          Authorization: `Bearer ${await dispatch("generateToken")}`
        }
      });
      if (setData) commit("setOvertime", data.docs);
      else return data.docs;
    },

    async createOvertime({ dispatch, state }, data) {
      try {
        await Axios({
          method: "POST",
          url: `${state.beURL}/overtime`,
          headers: {
            Authorization: `Bearer ${await dispatch("generateToken")}`
          },
          data
        });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("setSnackbar", {
          text: "Signed Up Succesfully!",
          color: "accent"
        });
      }
    },

    async getOverTimeConfig({ state, dispatch, commit }) {
      const { data } = await Axios({
        method: "GET",
        url: `${state.beURL}/settings/overtime`,
        headers: {
          Authorization: `Bearer ${await dispatch("generateToken")}`
        }
      });
      data.docs.forEach(doc => {
        if (doc.name == "blackout-dates") commit("setBlackOutDates", doc.value);
        if (doc.name == "maxDailySignups")
          commit("setMaxDailySignups", doc.value);
        if (doc.name == "maxWeeklySignups")
          commit("setMaxWeeklySignups", doc.value);
      });
    },

    async generateToken() {
      return await jwt.sign({}, SECRET, {
        expiresIn: "20 minutes"
      });
    }
  }
});
